import styled from '@mui/material/styles/styled';

export const Root = styled('div')({
  padding: 48
});